// extracted by mini-css-extract-plugin
module.exports = {"Tech":"Tech_Tech__207rx","Tech__Image":"Tech_Tech__Image__3HEWA"};